import React from 'react';

import { getRoot } from 'mobx-easy';
import { UpdateVehicleOnRunProps } from '@bringg-frontend/routes-planner';

import VehicleAssignerModal from 'bringg-web/features/runs-assignment/vehicle-assignment/vehicle-assigner-modal';
import { useRouteTrailer } from '../hooks/use-route-trailer';
import useRouteMonitoringStore from '../stores/helpers/use-route-monitoring-store';
import RootStore from 'bringg-web/stores/root-store';

const VehicleAssignerTool = ({
	routeId,
	onCloseModal,
	doNotNotifyServerOnAssign,
	hideUnassignVehicleButton,
	onVehicleUpdate
}: {
	routeId: number;
	onCloseModal: () => void;
	hideUnassignVehicleButton?: boolean;
	doNotNotifyServerOnAssign?: boolean;
	onVehicleUpdate?: ({ runId, vehicleId, tasksIds }: UpdateVehicleOnRunProps) => void;
}) => {
	const {
		routesMonitoringStore: { tasksByRun },
		routeMonitoringActionsStore: { startAssignVehicleListeners }
	} = useRouteMonitoringStore();

	// need this merge as task_ids may be undefined after 'run update' event
	const route = getRoot<RootStore>().data.runStore.get(routeId);
	const routeTasks = [...(tasksByRun.get(routeId)?.values() || [])];
	const { trailerId } = useRouteTrailer(route);

	return (
		<VehicleAssignerModal
			onClose={onCloseModal}
			modalParams={{
				data: {
					runId: route.id,
					userId: route.user_id,
					vehicleId: route.vehicle_id,
					trailerId: trailerId,
					tasks: routeTasks,
					teamIds: [route.team_id],
					weight: { value: route.weight_capacity, maxValue: route.max_weight }
				},
				doNotNotifyServerOnAssign,
				hideUnassignVehicleButton,
				handleListUpdate: onVehicleUpdate
			}}
			startRealtimeAsync={eventData =>
				!doNotNotifyServerOnAssign && startAssignVehicleListeners(routeId, eventData)
			}
		/>
	);
};

export default VehicleAssignerTool;
